import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CoinsSwap02 = function CoinsSwap02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m6 6 2-2m0 0L6 2m2 2H6C3.7909 4 2 5.7909 2 8m16 10-2 2m0 0 2 2m-2-2h2c2.2091 0 4-1.7909 4-4M10.189 6.5C10.8551 3.9122 13.2042 2 16 2c3.3137 0 6 2.6863 6 6 0 2.7957-1.9121 5.1449-4.4999 5.811M14 16c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6 2.6863-6 6-6 6 2.6863 6 6"
    })
  }));
};
export default CoinsSwap02;